import app from 'flarum/app';
import {extend} from 'flarum/extend';
import PostUser from 'flarum/components/PostUser';
import Link from 'flarum/components/Link';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

// import Discussion from 'flarum/common/models/Discussion';
import TerminalPost from 'flarum/forum/components/TerminalPost';

import Button from 'flarum/common/components/Button';
import FieldSet from 'flarum/common/components/FieldSet';
import SettingsPage from 'flarum/common/components/SettingsPage';
import UserCard from 'flarum/common/components/UserCard';
import Switch from 'flarum/common/components/Switch';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';


app.initializers.add('neko/choose-username-colour', () => {
    User.prototype.colour = Model.attribute('colour');

    extend(SettingsPage.prototype, 'oninit', function () {
        this.colour = app.session.user.data.attributes.colour;
    });

    extend(SettingsPage.prototype, 'settingsItems', function (items) {
        // if (app.forum.data.attributes.canSaveDrafts) {
            items.add(
                'username-colour',
                FieldSet.component(
                    {
                        label: 'Username Colour',
                        className: 'Settings-colour',
                    },
                    this.usernameColourItems().toArray()
                )
            );
        // }
    });

    SettingsPage.prototype['usernameColourItems'] = function () {
        const items = new ItemList();

        items.add(
            'uname-colour',

                <label>
                    <p>Please enter a 6 character hexidecimal colour code.</p>
                    <input className="FormControl" id="custom-colour" type="text" min="6" max="6" value={this.colour} />

                    {Button.component(
                        {
                            className: 'Button Button--primary',
                            onclick: () => {
                                const isInt = (str) => str == Math.round(str);
                                var re = /[0-9A-Fa-f]{6}/g;


                                var prev = this.colour;
                                var customColour = document.getElementById('custom-colour').value;

                                if (customColour.length !== 6 || !re.test(customColour) ) {
                                    this.colourInvalid = true;
                                    this.colour = prev;
                                    m.redraw();
                                } else {
                                    this.colourInvalid = false;
                                    this.user.save({ colour: customColour }).then(() => {
                                        this.colour = customColour;
                                        m.redraw();

                                    });
                                }
                            },
                        },
                        'Update Colour'
                    )}
                    {this.colourInvalid ? (
                        <p class="invalidInterval">
                            <small>You have entered an invalid colour code.</small>
                        </p>
                    ) : (
                        ''
                    )}
                </label>
        );

        return items;
    };



    extend(TerminalPost.prototype, 'view', function (vnode) {
	    const discussion = this.attrs.discussion;
	    const lastPost = this.attrs.lastPost && discussion.replyCount();

	    const user = discussion[lastPost ? 'lastPostedUser' : 'user']();

        if (!user) {
            return;
        }

        const colour = user.data.attributes.colour;

        if (!colour) {
        	return;
        }

        const matchTag = tag => {
            return node => node && node.tag && node.tag === tag;
        };

        const matchClass = className => {
            return node => node && node.attrs && node.attrs.className && node.attrs.className === className;
        };

        // Set the colour of the username class
        const username_link = vnode.children.find(matchTag('['))
            .children.find(matchClass('username'));

        username_link.attrs = username_link.attrs || {};
        username_link.attrs.style = username_link.attrs.style || {};
        username_link.attrs.style.color = '#' + colour;

    });

    extend(UserCard.prototype, 'view', function (vnode) {
        const user = this.attrs.user;

        if (!user) {
            return;
        }

        const colour = user.data.attributes.colour;

        if (!colour) {
            return;
        }

        const matchTag = tag => {
            return node => node && node.tag && node.tag === tag;
        };

        const matchClass = className => {
            return node => node && node.attrs && node.attrs.className && node.attrs.className === className;
        };

        var username_link = vnode.children[0].children[0].children.find(matchClass('UserCard-profile')).children.find(matchClass('UserCard-identity'))
            .children.find(matchClass('username'));

        if ( typeof username_link === 'undefined' ) {
            username_link = vnode.children[0].children[0].children.find(matchClass('UserCard-profile')).children.find(matchClass('UserCard-identity'))
            .children[0];
        }

        username_link.attrs = username_link.attrs || {};
        username_link.attrs.style = username_link.attrs.style || {};
        username_link.attrs.style.color = '#' + colour;
    });











    extend(PostUser.prototype, 'view', function (vnode) {
        const user = this.attrs.post.user();

        // If the post belongs to a deleted user, skip
        if (!user) {
            return;
        }

        const colour = user.data.attributes.colour;

        if (!colour) {
        	return;
        }

        const matchTag = tag => {
            return node => node && node.tag && node.tag === tag;
        };

        const matchClass = className => {
            return node => node && node.attrs && node.attrs.className && node.attrs.className === className;
        };

        // Set the colour of the username class
        const username_link = vnode.children.find(matchTag('h3'))
            .children.find(matchTag(Link))
            .children.find(matchClass('username'));

        username_link.attrs = username_link.attrs || {};
        username_link.attrs.style = username_link.attrs.style || {};
        username_link.attrs.style.color = '#' + colour;
    });
});
